import { render, staticRenderFns } from "./Cors.vue?vue&type=template&id=4a645b09&scoped=true&"
import script from "./Cors.vue?vue&type=script&lang=js&"
export * from "./Cors.vue?vue&type=script&lang=js&"
import style0 from "./Cors.vue?vue&type=style&index=0&id=4a645b09&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a645b09",
  null
  
)

export default component.exports